module.exports = __webpack_public_path__ + "img/guessWa.609383c5.svg";